import { NgModule } from '@angular/core';
import { OmniLiveAvailabilityStateModule } from '@cigna/omni/live-availability-state';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import {
  ConversationsEffects,
  conversationsReducer,
  OmniConversationsFacade,
  CONVERSATIONS_FEATURE_KEY,
  ConversationsAnalyticsEffects,
} from './+state';
import { TitleCasePipe } from '@angular/common';
@NgModule({
  imports: [
    StoreModule.forFeature(CONVERSATIONS_FEATURE_KEY, conversationsReducer),
    EffectsModule.forFeature([
      ConversationsEffects,
      ConversationsAnalyticsEffects,
    ]),
    OmniLiveAvailabilityStateModule,
  ],
  providers: [OmniConversationsFacade, TitleCasePipe],
})
export class OmniConversationsStateModule {}
